import React, { CSSProperties, useState } from 'react';
import styled from 'styled-components';
import { Checkbox } from './Input';

export interface Data {
  value: string;
  label: string;
}

export interface Props {
  data: Data[];
  disabled?: boolean;
  onChange: (selectedItems: string[]) => void;
  style: CSSProperties;
}

const Panel = styled.div`
`;

const Item = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  &:hover {
    cursor: pointer;
  }
`;

export const Checkboxes = (props: Props) => {
  const { data, disabled, style } = props;
  const [checkedItems, setCheckedItems] = useState<string[]>([]);

  const updateCheckedItems = (items: string[]) => {
    setCheckedItems(items);
    props.onChange(items);
  };

  const addItem = (value: string) => {
    const copy = checkedItems.slice();
    copy.push(value);
    updateCheckedItems(copy);
  };

  const removeItem = (value: string) => {
    const copy = checkedItems.slice();
    const i = copy.indexOf(value);
    if (i >= 0) {
      copy.splice(i, 1);
    }
    updateCheckedItems(copy);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      addItem(e.target.value);
    } else {
      removeItem(e.target.value);
    }
  };

  return (
    <Panel style={style}>
      {data.map((d) => (
        <Item key={d.value}>
          <Checkbox
            disabled={disabled}
            onChange={onChange}
            style={{ marginRight: '.5rem' }}
            value={d.value}
            checked={checkedItems.includes(d.value)}
          />
          <Label
            onClick={() => {
              disabled
                || checkedItems.includes(d.value) ? removeItem(d.value) : addItem(d.value);
            }}
            style={{ opacity: disabled ? 0.3 : 1 }}
          >
            {d.label}
          </Label>
        </Item>
      ))}
    </Panel>
  );
};
